import { Icon } from '@iconify/react';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { validateProps } from '../../../../utils/propValidator';
import ModalWrapper from './ModalWrapper';

const propRules = {
  open: { type: 'boolean', required: true },
  onClose: { type: 'function', required: true },
  title: { type: 'string' },
  message: { type: ['string', 'node'], required: true },
  onConfirm: { type: 'function', required: true },
  confirmText: { type: 'string' },
  cancelText: { type: 'string' },
  icon: { type: 'string' },
  loading: { type: 'boolean' },
  sx: { type: 'object' },
};

export default function ConfirmationModal(props: any) {
  validateProps(props as Record<string, unknown>, propRules, 'ConfirmationModal');
  const {
    open,
    onClose,
    title = 'Are you sure?',
    message,
    onConfirm,
    confirmText = 'Yes',
    cancelText = 'Cancel',
    icon,
    loading,
    sx = {},
  } = props;

  return (
    <ModalWrapper
      open={open}
      onClose={loading ? undefined : onClose}
      sx={{ alignItems: 'center', color: 'grey.500', gap: 2, ...sx }}
      maxWidth='fit-content'
    >
      {icon && <Icon icon={icon} width={32} />}
      {title &&
        (typeof title === 'string' ? (
          <Typography sx={{ fontSize: '1.125rem', color: 'grey.500' }}>{title}</Typography>
        ) : (
          title
        ))}
      {message &&
        (typeof message === 'string' ? (
          <Typography sx={{ fontSize: '1rem', color: 'grey.500' }}>{message}</Typography>
        ) : (
          message
        ))}
      <Stack direction='row' justifyContent='center' alignItems='center' gap={2} sx={{ mt: 2 }}>
        <button type='button' className='btn outlined-btn' onClick={onClose} disabled={loading}>
          {cancelText}
        </button>
        <button type='button' className='btn cta-btn' onClick={onConfirm} disabled={loading}>
          {confirmText}
        </button>
      </Stack>
    </ModalWrapper>
  );
}
